import * as React from "react";

import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import SendIcon from "@mui/icons-material/Send";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ChatIcon from "@mui/icons-material/Chat";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";

import PeopleIcon from "@mui/icons-material/People";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import DockIcon from "@mui/icons-material/Dock";
import ContactsIcon from "@mui/icons-material/Contacts";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { Link } from "react-router-dom";

export default function NestedList() {
  const [open, setOpen] = React.useState(true);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <List
      sx={{
        width: "100%",
        maxWidth: 360,
        // minWidth: "500px",
        marginRight: 100,

        // marginRight: 1000,
      }}
      component="nav"
      aria-labelledby="nested-list-subheader"
      // subheader={
      //   <ListSubheader component="div" id="nested-list-subheader" >
      //     {/* <Typography variant="body1" sx={{ color: "text.secondary" }}> */}
      //     Страницы сайта
      //     {/* </Typography> */}
      //   </ListSubheader>
      // }
    >
      <Link to="/">
        <ListItemButton>
          <ListItemIcon>
            <ChatIcon />
          </ListItemIcon>
          <ListItemText primary="ИНФО" />
        </ListItemButton>
      </Link>

      <Link to="/zayavka">
        <ListItemButton>
          <ListItemIcon>
            <SendIcon />
          </ListItemIcon>
          <ListItemText primary="отправить заявку на соревнование" />
        </ListItemButton>
      </Link>

      <Link to="/calendar">
        <ListItemButton>
          <ListItemIcon>
            <CalendarMonthIcon />
          </ListItemIcon>
          <ListItemText primary="календарь" />
        </ListItemButton>
      </Link>

      <Link to="/documents">
        <ListItemButton>
          <ListItemIcon>
            <DockIcon />
          </ListItemIcon>
          <ListItemText primary="документы" />
        </ListItemButton>
      </Link>

      <Link to="/polog">
        <ListItemButton>
          <ListItemIcon>
            <DockIcon />
          </ListItemIcon>
          <ListItemText primary="положения" />
        </ListItemButton>
      </Link>

      <Link to="/protocol">
        <ListItemButton>
          <ListItemIcon>
            <DockIcon />
          </ListItemIcon>
          <ListItemText primary="протоколы" />
        </ListItemButton>
      </Link>

      <Link to="/norm">
        <ListItemButton>
          <ListItemIcon>
            <FitnessCenterIcon />
          </ListItemIcon>
          <ListItemText primary="нормативы" />
        </ListItemButton>
      </Link>

      <Link to="/record">
        <ListItemButton>
          <ListItemIcon>
            <FitnessCenterIcon />
          </ListItemIcon>
          <ListItemText primary="рекорды рязанской области" />
        </ListItemButton>
      </Link>
      <Link to="/sportsmens">
        <ListItemButton>
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <ListItemText primary="наши спортсмены" />
        </ListItemButton>
      </Link>
      <Link to="/lk">
        <ListItemButton>
          <ListItemIcon>
            <AccountCircleIcon />
          </ListItemIcon>
          <ListItemText primary="личный кабинет" />
        </ListItemButton>
      </Link>
      <Link to="/albom">
        <ListItemButton>
          <ListItemIcon>
            <PhotoCameraIcon />
          </ListItemIcon>
          <ListItemText primary="фото" />
        </ListItemButton>
      </Link>
      <Link to="/anti">
        <ListItemButton>
          <ListItemIcon>
            <ReportProblemIcon />
          </ListItemIcon>
          <ListItemText primary="антидопинг" />
        </ListItemButton>
      </Link>
      <Link to="/contacts">
        <ListItemButton>
          <ListItemIcon>
            <ContactsIcon />
          </ListItemIcon>
          <ListItemText primary="контакты" />
        </ListItemButton>
      </Link>
    </List>
  );
}
